import { useCategoryTreeItem } from '../categoryTree';
import { SecondButtonActions } from '../compat/tvpil';
import { RhinoImageRatio } from '../image';

import { getChannelIconSettings } from './utils/getChannelIconSettings';

type UseMaxiPlayerSettingsProps = {
  referenceId: string;
};

export type MaxiPlayerSettings = {
  channelIconType: number | undefined;
  channelIconRatio: RhinoImageRatio;
  secondaryButtonAction: SecondButtonActions;
};

export const useMaxiPlayerSettings = ({ referenceId }: UseMaxiPlayerSettingsProps): MaxiPlayerSettings | undefined => {
  const category = useCategoryTreeItem(referenceId);

  if (!category) {
    return;
  }

  const channelIconSettings = getChannelIconSettings(category.railImageProperty.channelPresentationImageType);

  return {
    channelIconRatio: channelIconSettings.channelIconRatio,
    channelIconType: channelIconSettings.channelIconType,
    secondaryButtonAction:
      (category.railProperty.secondButtonAction as SecondButtonActions) || SecondButtonActions.details_page,
  };
};
